import React from 'react';
import ExpertiseSection from '../../components/ExpertiseSection/ExpertiseSection';
// import appExpertiseNative from '../../assets/app-development/app-expertise-native-development.png';
// import appExpertiseCross from '../../assets/app-development/app-expertise-cross-platform.png';
// import appExpertiseMobileFirst from '../../assets/app-development/app-expertise-mobile-first.png';
// import appExpertisePerformance from '../../assets/app-development/app-expertise-performance-security.webp';

import appExpertiseNative from '../../assets/app-development/app-expertise/mobile-development.webp';
import appExpertiseCross from '../../assets/app-development/app-expertise/Cross-platform.webp';
import appExpertiseMobileFirst from '../../assets/app-development/app-expertise/mobile-first-strategie.webp';
import appExpertisePerformance from '../../assets/app-development/app-expertise/performance-security.webp';

const expertiseData = [
  {
    id: 1,
    title: 'Native App Entwicklung',
    description: 'Für iOS und Android entwickeln wir leistungsstarke native Anwendungen, die die vollständigen Möglichkeiten der jeweiligen Plattform ausschöpfen. So profitieren Sie von optimaler Performance und nahtloser Integration.',
    image: appExpertiseNative,
  },
  {
    id: 2,
    title: 'Cross-Platform Lösungen',
    description: 'Mit modernen Frameworks wie React Native und Flutter erstellen wir plattformübergreifende Apps, die eine konsistente Nutzererfahrung bieten und gleichzeitig Entwicklungszeiten verkürzen – ohne Kompromisse bei der Qualität.',
    image: appExpertiseCross,
  },
  {
    id: 3,
    title: 'Mobile-First Strategie',
    description: 'Wir denken von Anfang an mobil: Unsere Apps werden speziell für mobile Nutzungsszenarien konzipiert und entwickelt. So entstehen intuitive, schnelle und für Smartphones optimierte Lösungen, die auch auf Tablets und Desktops überzeugen.',
    image: appExpertiseMobileFirst,
  },
  {
    id: 4,
    title: 'Performance & Sicherheit',
    description: 'Wir optimieren die Performance Ihrer App und implementieren strenge Sicherheitsstandards, um einen schnellen, zuverlässigen und geschützten Betrieb sicherzustellen.',
    image: appExpertisePerformance,
  }
];

function AppExpertise() {
  return (
    <div className="app-expertise">
      <ExpertiseSection
        headerTitle="App Entwicklung Expertise"
        headerSubtitle="Innovative mobile Lösungen für Ihre Geschäftsidee"
        items={expertiseData}
        theme="app-development"
      />
    </div>
  );
}

export default AppExpertise;
